import { render, staticRenderFns } from "./LinkCodeBox.vue?vue&type=template&id=6ae4ccf4&"
import script from "./LinkCodeBox.vue?vue&type=script&lang=js&"
export * from "./LinkCodeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports